import {AvatarStack} from '@primer/react'
import {GitHubAvatar} from '@github-ui/github-avatar'
import type {PreviewAuthor} from '../../page-data/payloads/thread-previews'

export function PreviewAuthors({commentAuthors}: {commentAuthors: PreviewAuthor[]}) {
  if (commentAuthors.length < 1) return null

  return (
    <AvatarStack>
      {commentAuthors.map(({login, avatarUrl}) => (
        <GitHubAvatar key={login} alt={login} size={18} src={avatarUrl} />
      ))}
    </AvatarStack>
  )
}
